export default __webpack_public_path__ + "static/media/question.5f7cb506.svg";